import { HomeHero } from 'scripts/animations/three/home-hero';
import { DirectionalLight } from 'three';

export const PrimaryLight = new DirectionalLight(
    HomeHero.Colors.PrimaryLight.violet.color,
    HomeHero.Colors.PrimaryLight.violet.intensity,
);
PrimaryLight.name = 'PrimaryLight';
PrimaryLight.position.set(-2.28, 362.96, 376.43);
PrimaryLight.rotation.set(0, -0.73, 0);
PrimaryLight.castShadow = true;
PrimaryLight.shadow.mapSize.width = 4096;
PrimaryLight.shadow.mapSize.height = 4096;
PrimaryLight.shadow.camera.near = -10_000;
PrimaryLight.shadow.camera.far = 10_000;
PrimaryLight.shadow.camera.left = -5_000;
PrimaryLight.shadow.camera.right = 5_000;
PrimaryLight.shadow.camera.top = 5_000;
PrimaryLight.shadow.camera.bottom = -5_000;


export const SecondaryLight = new DirectionalLight(
    HomeHero.Colors.SecondaryLight.violet.color,
    HomeHero.Colors.SecondaryLight.violet.intensity,
);
SecondaryLight.name = 'SecondaryLight';
SecondaryLight.position.set(152.24, -269.51, -465.67);
SecondaryLight.rotation.set(0, -0.73, 0);
SecondaryLight.castShadow = true;
SecondaryLight.shadow.mapSize.width = 2048;
SecondaryLight.shadow.mapSize.height = 2048;
SecondaryLight.shadow.camera.near = -10_000;
SecondaryLight.shadow.camera.far = 10_000;
SecondaryLight.shadow.camera.left = -625;
SecondaryLight.shadow.camera.right = 625;
SecondaryLight.shadow.camera.top = 625;
SecondaryLight.shadow.camera.bottom = -625;
